import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { APIURL, TZ } from '../../../Global';
import { list } from '../AddLabTest/sampleList'
import AddItemBase from '../AddLabTest/AddGroup/AddItemBase';
import { useAlert } from 'react-alert';
import { FaCheck, FaTrash } from 'react-icons/fa';
const AddClinic = ({ hospitals, group, handleSuccess, onClose }) => {

    const alert = useAlert();
    const [sample, setSample] = useState(hospitals?.[0]?.health_care_type || 'ModernMedicine');
    const [selectedItems, setSelectedItems] = useState([]);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        if (hospitals) {
            setSelectedItems(
                hospitals.map(hospital => ({
                    id: hospital.id,
                    name: hospital.name,
                    added: true
                }))
            );
        }
    }, [hospitals]);

    useEffect(() => {
        const fetchData = async () => {
            const tokenString = sessionStorage.getItem('usertoken');
            const str = tokenString?.replace(/["]+/g, '');

            try {
                const response = await axios.get(`${APIURL}/api/v1/staff/hospital-approve/`, {
                    headers: { Authorization: 'Token ' + str },
                    params: {
                        health_care_type: sample.replace(/\s+/g, ''),
                        status: 'approved'
                    }
                });

                if (response.data.status === 'success') {
                    setOptions(response.data.hospitals.map(hospital => ({
                        ...hospital,
                        id: hospital.id,
                        name: hospital.name,
                        added: selectedItems.some(item => item.id === hospital.id && item.added)
                    })));
                }
            } catch (error) {
                console.error('Error fetching hospitals:', error);
                setOptions([]);
                alert.error('Error fetching hospitals.');
            }
        };

        fetchData();
    }, [sample, alert]);

    const handleCategoryClick = (category) => {
        setSample(category);
    };

    const handleSelectItem = (item) => {
        setSelectedItems(prev =>
            prev.some(i => i.id === item.id)
                ? prev.filter(i => i.id !== item.id)
                : [...prev, { ...item, added: false }]
        );
    };

    const handleRemoveItem = (item) => {
        if (item.added) return;
        setSelectedItems(prev => prev.filter(i => i.id !== item.id));
    };

    const handleSubmit = async () => {
        if (!group?.id) {
            alert.error('Group is mandatory');
            return;
        }

        const newlyAddedHospitals = selectedItems.filter(item => !item.added);
        if (newlyAddedHospitals.length === 0) {
            alert.error('Add new clinics')
            return
        }
        const payload = {
            method: 'add',
            group_id: group.id,
            hospital_ids: newlyAddedHospitals.map(item => String(item.id))
        };

        try {
            const tokenString = sessionStorage.getItem('usertoken');
            const str = tokenString?.replace(/["]+/g, '');

            const res = await axios.put(
                `${APIURL}/api/v1/staff/hospital-group/?group_id=${group.id}&${TZ}`,
                payload,
                { headers: { Authorization: 'Token ' + str } }
            );

            if (res.status === 200 && res.data.status === 'success') {
                alert.success('Clinics updated successfully!');
                handleSuccess();
                onClose();
            } else {
                alert.error(res.data.message || 'Failed to update clinics.');
            }
        } catch (err) {
            alert.error('Failed to update clinics. Please try again.');
            console.error('API Error:', err);
        }
    };

    const filteredOptions = (searchTerm) => {
        return options.filter(item =>
            !searchTerm || item.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
    };

    const renderSamplesColumn = () => (
        <div className="samples-column">
            <div className="samples-header">Health care type</div>
            <div className="samples-list" style={{ borderRadius: 0, border: "none" }}>
                {list.map((category) => (
                    <button
                        key={category}
                        className={`sample-button ${sample === category ? "active" : ""}`}
                        onClick={() => handleCategoryClick(category)}
                        disabled={selectedItems.length > 0}
                        style={{ cursor: selectedItems.length > 0 && sample !== category && 'not-allowed' }}
                    >
                        {category}
                    </button>
                ))}
            </div>
        </div>
    );

    const renderItemsList = (searchTerm) => {
        const items = filteredOptions(searchTerm);
        return items.length > 0 ? (
            items.map((item) => {
                const isAdded = selectedItems.some(selected =>
                    selected.id === item.id && selected.added
                );
                const isSelected = selectedItems.some(selected => selected.id === item.id);

                return (
                    <div
                        key={item.id}
                        className={`item-card ${isSelected ? 'selected' : ''} ${isAdded ? 'added-item' : ''}`}
                        onClick={() => {
                            if (!isAdded) {
                                handleSelectItem(item);
                            }
                        }}
                    >
                        <div className="item-content">
                            {item.name}
                            {isAdded && <span className="added-badge">(Already added)</span>}
                        </div>
                        {isSelected && <FaCheck className="selected-icon" />}
                    </div>
                );
            })
        ) : (
            <div className="empty-message">
                {searchTerm
                    ? 'No clinics match your search'
                    : 'No clinics available'}
            </div>
        );
    };

    const renderSelectedList = () => {
        return selectedItems.length > 0 ? (
            selectedItems.map((item) => (
                <div key={item.id} className="selected-item">
                    <span>
                        {item.name}
                    </span>
                    {!item.added && (
                        <FaTrash
                            className="remove-icon"
                            onClick={() => handleRemoveItem(item)}
                        />
                    )}
                </div>
            ))
        ) : (
            <div className="empty-message">
                No clinics selected
            </div>
        );
    };

    return (
        <AddItemBase
            type="clinic"
            group={group}
            onClose={onClose}
            handleSuccess={handleSuccess}
            renderSamplesColumn={renderSamplesColumn}
            renderItemsList={renderItemsList}
            renderSelectedList={renderSelectedList}
            handleSubmit={handleSubmit}
            selectedItems={selectedItems}
        />
    );
};

export default AddClinic;